import { MobizRole } from './mobiz-role.do';
import { SecurityScope } from './security-scope';
import { SerializableObject } from './serializable-object';

/**
 * Dependencies of the Group
 */
export enum MobizGroupEagerLoad {
  None = 0,
  Roles = 1,
  All = 1,
}

export class MobizGroup extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public module: string;
  public key: string;
  public scope: SecurityScope;
  public scopeId: string;
  public name: string;
  public roles: MobizRole[];

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'roles':
        let roles: MobizRole[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(roleData => {
            let role = new MobizRole(roleData);
            roles.push(role);
          });
        }
        return roles;

      case 'modifiedUtc':
      case 'createdUtc':
        if (typeof propertyValue === 'string') {
          return new Date(propertyValue);
        }
        return propertyValue;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

  public isReadOnly(): boolean {
    return this.scope === SecurityScope.BuiltIn;
  }

}
